import React, { useMemo, useState, useEffect } from "react";

const company = {
  name: "L&P Assessoria Empresarial",
  whatsappNumber: "5547992218551",
  whatsappDisplay: "47 99221-8551",
  instagram: "@lisane.assessoria",
  email: "contato@lpassessoria.com.br",
  city: "Blumenau/SC",
};

const services = [
  {
    title: "Abertura de Empresas",
    description:
      "Elaboração dos atos constitutivos, registros e condução completa do processo para que a empresa comece a operar com estrutura adequada.",
  },
  {
    title: "Alterações Contratuais",
    description:
      "Atualização de dados societários, administrativos e operacionais com segurança, clareza e alinhamento com a realidade do negócio.",
  },
  {
    title: "Transformações Societárias",
    description:
      "Mudanças de natureza jurídica e reorganizações societárias conduzidas com análise técnica e foco em viabilidade operacional.",
  },
  {
    title: "Baixa e Extinção de Empresas",
    description:
      "Encerramento formal com acompanhamento dos procedimentos necessários para evitar pendências futuras.",
  },
  {
    title: "Fusão, Cisão e Incorporação",
    description:
      "Estruturação e acompanhamento de operações empresariais com visão estratégica, jurídica e documental.",
  },
  {
    title: "M&A – Fusões e Aquisições",
    description:
      "Assessoria em operações de compra e venda de empresas, incluindo due diligence jurídica, estruturação societária da operação, elaboração e negociação de contratos, acordo de sócios e governança.",
  },
  {
    title: "Valuation",
    description:
      "Avaliação de empresas para venda, entrada de investidores, reorganização societária, planejamento sucessório e entrada ou saída de sócios.",
  },
  {
    title: "Protocolos e Acompanhamento",
    description:
      "Atuação perante Junta Comercial, Receita Federal, órgãos estaduais e municipais conforme a necessidade de cada demanda.",
  },
  {
    title: "Registro em Conselhos de Classe",
    description:
      "Suporte para registro de empresas e profissionais em órgãos como CORE, COREN, CRM, CREA, CRECI, CREF e outros.",
  },
  {
    title: "Planejamento Tributário e Sucessório",
    description:
      "Estudo e estruturação de holdings patrimoniais e familiares para organizar patrimônio, reduzir riscos e melhorar a eficiência tributária.",
  },
  {
    title: "Revisão de Contratos Empresariais",
    description:
      "Análise técnica e reformulação de contratos com atenção a responsabilidade tributária, compliance e adaptação a mudanças legislativas.",
  },
  {
    title: "Regularização de Obras",
    description:
      "Condução técnica, administrativa e fiscal necessária para a legalização da obra junto aos órgãos municipais e federais.",
  },
  {
    title: "Acessos para Nota Fiscal",
    description:
      "Criação de acessos para emissão de notas fiscais eletrônicas em casos de abertura, alteração de endereço ou transferência de UF.",
  },
  {
    title: "Serviços Complementares",
    description:
      "Apoio em demandas como CNES, DANC, CNO, SCPO e SERO/DCTFWeb, conforme a necessidade do cliente e da atividade.",
  },
  {
    title: "Domicílio Fiscal",
    description: "Regularização do endereço fiscal da empresa com mais segurança jurídica e organização cadastral.",
  },
];

const benefits = [
  "Mais segurança jurídica e empresarial",
  "Menos burocracia e retrabalho",
  "Acompanhamento técnico e estratégico",
  "Maior organização societária e documental",
  "Mais eficiência tributária e operacional",
  "Redução de riscos em decisões empresariais",
];

const highlights = [
  "Atuação personalizada para cada cliente",
  "Mais de 15 anos de experiência em Direito Empresarial",
  "Visão integrada: societária, contratual, tributária e patrimonial",
  "Suporte para empresas, contabilidades, imobiliárias e profissionais liberais",
];

const pricing = [
  ["Abertura de empresa (com licenciamentos)", "R$ 600,00"],
  ["Alteração contratual (com licenciamentos)", "R$ 600,00"],
  ["Baixa / Extinção de empresa (com licenciamentos)", "R$ 600,00"],
  ["Transferência de UF (com licenciamentos)", "R$ 600,00"],
  ["Fusão empresarial (com licenciamentos)", "R$ 800,00"],
  ["Cisão empresarial (com licenciamentos)", "R$ 800,00"],
  ["Incorporação empresarial (com licenciamentos)", "R$ 800,00"],
  ["Registro em Conselho de Classe", "R$ 250,00 a R$ 600,00"],
  ["Criação de acesso para emissão de notas fiscais", "R$ 250,00"],
  ["Cadastro CNES", "R$ 480,00"],
  ["Estudo tributário e planejamento sucessório – análise inicial", "R$ 250,00"],
  ["Planejamento tributário e sucessório completo para holdings", "R$ 600,00"],
  ["Revisão, análise e reformulação de contratos", "R$ 450,00"],
  ["DANC", "R$ 250,00"],
  ["CNO", "R$ 600,00 a R$ 1.200,00"],
  ["SERO / DCTFWeb", "R$ 450,00 a R$ 1.500,00"],
  ["SCPO", "R$ 200,00"],
];

const meiHighlights = [
  "Pagamento mensal do DAS",
  "Declaração anual do MEI",
  "Menos dúvidas com papelada e obrigações",
  "Atendimento para quem quer focar no próprio trabalho",
];

const meiBenefits = [
  "Mais tranquilidade para manter o MEI regular",
  "Redução do risco de atraso, multa e desorganização",
  "Acompanhamento próximo para dúvidas do dia a dia",
  "Mais tempo para cuidar do negócio e vender",
];

const fiscalAddressHighlights = [
  "Endereço fiscal regularizado para registro da empresa",
  "Suporte para utilização perante CNPJ, Receita Federal e Junta Comercial",
  "Mais organização administrativa para abertura e manutenção da empresa",
  "Solução profissional para empresas que precisam de domicílio fiscal",
];

const fiscalAddressBenefits = [
  "Mais segurança jurídica para o funcionamento do negócio",
  "Base adequada para abertura, regularização e continuidade da empresa",
  "Redução de problemas com endereço fiscal irregular ou inadequado",
  "Acompanhamento técnico para orientar a melhor estrutura cadastral",
];

function App() {
  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    email: "",
    mensagem: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    document.title =
      "L&P Assessoria Empresarial | Serviços Societários, Contratuais, MEI e Regularização";
  }, []);

  const whatsappDefaultMessage = useMemo(() => {
    return encodeURIComponent(
      "Olá! Vim pelo site da L&P Assessoria Empresarial e gostaria de falar com um especialista."
    );
  }, []);

  const whatsappLink = `https://wa.me/${company.whatsappNumber}?text=${whatsappDefaultMessage}`;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    try {
      setIsSubmitting(true);

      const response = await fetch("https://lpassessoria.adv.br/contato.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        window.open(result.whatsapp_url, "_blank");

        setFormData({
          nome: "",
          telefone: "",
          email: "",
          mensagem: "",
        });

        alert("Mensagem enviada com sucesso.");
      } else {
        alert(result.message || "Erro ao enviar formulário.");
      }
    } catch (error) {
      console.error("Erro ao enviar formulário:", error);
      alert("Erro ao conectar com o servidor.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToContact = () => {
    const section = document.getElementById("contato");
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="app">
      <a
        href={whatsappLink}
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="/whatsapp.png"
          alt="WhatsApp"
          className="whatsapp-icon"
          style={{ height: "35px", marginRight: "5px" }}
        />
        WhatsApp
      </a>

      <header className="header">
        <div className="container header-content">
          <div className="logo-box">
            <img
              src="/logo.png"
              alt="Logo L&P"
              className="whatsapp-icon"
              style={{ height: "85px", marginRight: "5px" }}
            />
            <div>
              <div className="item cinzel" style={{ fontSize: "20px" }}>
                <span style={{ color: "#8B1E2D" }}>L</span>&
                <span style={{ color: "#8B1E2D" }}>P</span> ASSESSORIA EMPRESARIAL
              </div>

              <p className="logo-subtitle">
                Estruturação societária, MEI e regularização empresarial
              </p>
            </div>
          </div>

          <nav className="nav">
            <a href="#sobre">Sobre</a>
            <a href="#servicos">Serviços</a>
            <a href="#diferencial">Nosso Diferencial</a>
            <a href="#mei">Plano MEI</a>
            <a href="#investimento">Investimento</a>
            <a href="#contato" className="nav-btn">
              Falar com Especialista
            </a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero">
          <div className="container hero-grid">
            <div className="hero-left">
              <span className="tag">Assessoria empresarial estratégica</span>
              <h2>Mais segurança para sua empresa.</h2>
              <p>
                A L&P Assessoria Empresarial oferece suporte completo para empresas,
                contabilidades, imobiliárias, profissionais liberais e MEIs, com atuação
                especializada em serviços societários, revisão contratual, planejamento
                tributário e sucessório, registros em conselhos de classe, regularização
                de obras, domicílio fiscal e assessoria para microempreendedores.
              </p>

              <div className="hero-buttons">
                <button className="btn btn-primary" onClick={scrollToContact}>
                  Solicitar Atendimento
                </button>
                <a
                  className="btn btn-outline"
                  href={whatsappLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  Falar com um Especialista
                </a>
              </div>

              <div className="hero-badges">
                <span>+15 anos de experiência</span>
                <span>Atuação técnica e personalizada</span>
                <span>Segurança jurídica e eficiência</span>
              </div>
            </div>

            <div className="hero-card">
              <span className="card-label">Atuação principal</span>
              <h3>Estruturação e regularização com visão estratégica</h3>
              <ul>
                <li>Constituição, alteração e baixa de empresas</li>
                <li>Fusão, cisão e incorporação</li>
                <li>Holdings patrimoniais e familiares</li>
                <li>Revisão de contratos empresariais</li>
                <li>Conselhos de classe e licenciamentos</li>
                <li>Domicílio fiscal, suporte para MEI e regularização de obras</li>
              </ul>
              <button className="btn btn-secondary" onClick={scrollToContact}>
                Quero uma Análise
              </button>
            </div>
          </div>
        </section>

        <section id="sobre" className="section section-light">
          <div className="container two-columns">
            <div>
              <span className="tag dark">Sobre a L&P</span>
              <h2 className="section-title dark-text">
                Experiência, técnica e personalização para decisões empresariais mais seguras.
              </h2>
            </div>

            <div className="content-box">
              <p>
                A L&P Assessoria Empresarial conta com atuação especializada há mais de
                15 anos na área de Direito Empresarial, com foco em estruturação societária,
                operações empresariais, análise contratual e planejamento estratégico.
              </p>
              <p>
                O trabalho é desenvolvido de forma técnica e personalizada, buscando
                segurança jurídica, eficiência tributária e organização empresarial.
              </p>
              <p>
                A assessoria atende desde constituição e alterações de empresas até
                transformações societárias, licenciamentos, holdings, revisão contratual,
                regularizações específicas, domicílio fiscal e suporte para MEI.
              </p>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="center-heading">
              <span className="tag">Por que escolher a L&P</span>
              <h2 className="section-title">Uma assessoria que não trabalha no automático</h2>
              <p>
                Cada demanda exige análise real, cuidado técnico e estratégia. É isso que evita
                erro, atraso e custo desnecessário.
              </p>
            </div>

            <div className="grid-4">
              {highlights.map((item, index) => (
                <div className="info-card" key={index}>
                  <h3>{item}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="servicos" className="section section-dark">
          <div className="container">
            <div className="center-heading">
              <span className="tag">Serviços</span>
              <h2 className="section-title">Soluções empresariais completas em um só lugar</h2>
              <p>
                A L&P reúne atuação societária, contratual, tributária, patrimonial e regulatória
                para apoiar seu negócio com mais segurança.
              </p>
            </div>

            <div className="services-grid">
              {services.map((service, index) => (
                <article className="service-card" key={index}>
                  <div className="service-icon">◆</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="diferencial" className="section section-light">
          <div className="container">
            <div className="center-heading">
              <span className="tag dark">Nosso Diferencial</span>
              <h2 className="section-title dark-text">
                Domicílio Fiscal para Empresa
              </h2>
              <p>
                Regularize o endereço fiscal do seu negócio com a L&P Assessoria.
              </p>
            </div>

            <div className="two-columns">
              <div className="content-box">
                <p>
                  Se você procura domicílio fiscal para empresa, a L&P Assessoria oferece
                  uma solução segura e profissional para regularizar o endereço da sua
                  empresa perante os órgãos públicos.
                </p>
                <p>
                  O domicílio fiscal é o endereço oficial da empresa utilizado para
                  registro no CNPJ, Receita Federal, Junta Comercial, Prefeitura e
                  demais órgãos reguladores.
                </p>
                <p>
                  Esse endereço é essencial para a abertura, regularização e funcionamento
                  de qualquer empresa no Brasil.
                </p>
              </div>

              <div className="content-box">
                <p>
                  A L&P Assessoria oferece suporte completo para empresas que precisam
                  de domicílio fiscal regularizado, garantindo organização administrativa
                  e segurança jurídica para o negócio.
                </p>
                <p>
                  Esse serviço é ideal para empresas que precisam estruturar corretamente
                  sua base cadastral, alinhar o endereço fiscal à formalização do negócio
                  e operar com mais tranquilidade.
                </p>
                <p>
                  Com acompanhamento técnico, você reduz riscos e ganha mais clareza
                  sobre os procedimentos necessários para manter sua empresa regular.
                </p>
              </div>
            </div>

            <div className="mei-columns" style={{ marginTop: "32px" }}>
              <div className="mei-panel">
                <h3 className="mei-panel-title">O que o serviço oferece</h3>

                <div className="mei-list">
                  {fiscalAddressHighlights.map((item, index) => (
                    <div className="mei-item" key={index}>
                      <span className="mei-check">✔</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mei-panel">
                <h3 className="mei-panel-title">Por que isso faz diferença</h3>

                <div className="mei-list">
                  {fiscalAddressBenefits.map((item, index) => (
                    <div className="mei-item" key={index}>
                      <span className="mei-check">✔</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={{ textAlign: "center", marginTop: "40px" }}>
              <a
                href={`https://wa.me/${company.whatsappNumber}?text=${encodeURIComponent(
                  "Olá! Vim pelo site da L&P Assessoria Empresarial e gostaria de saber mais sobre o serviço de domicílio fiscal para empresa."
                )}`}
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Quero saber mais
              </a>
            </div>
          </div>
        </section>

        <section className="section section-light">
          <div className="container">
            <div className="center-heading">
              <span className="tag dark">Benefícios</span>
              <h2 className="section-title dark-text">
                O cliente ganha clareza, segurança e estrutura para operar com mais tranquilidade
              </h2>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div className="benefit-card light" key={index}>
                  <span className="check">✔</span>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="mei" className="section">
          <div className="container">
            <div className="center-heading">
              <span className="tag">Plano de Assessoria para MEI</span>
              <h2 className="section-title">
                Menos burocracia para o MEI. Mais tempo para você cuidar do seu trabalho.
              </h2>
              <p>
                A L&P Assessoria oferece suporte para quem é MEI e quer manter a atividade em dia,
                com mais tranquilidade, organização e orientação prática no dia a dia.
              </p>
            </div>

            <div className="mei-columns">
              <div className="mei-panel">
                <h3 className="mei-panel-title">O que entra no apoio ao MEI</h3>

                <div className="mei-list">
                  {meiHighlights.map((item, index) => (
                    <div className="mei-item" key={index}>
                      <span className="mei-check">✔</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mei-panel">
                <h3 className="mei-panel-title">Por que isso importa</h3>

                <div className="mei-list">
                  {meiBenefits.map((item, index) => (
                    <div className="mei-item" key={index}>
                      <span className="mei-check">✔</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="notes-grid" style={{ marginTop: "32px" }}>
              <div className="note-card">
                <h3>Chega de papelada e dúvida</h3>
                <p>
                  Se a burocracia do MEI está travando sua rotina, a assessoria ajuda a organizar
                  as obrigações e reduzir a chance de erro.
                </p>
              </div>

              <div className="note-card">
                <h3>Foco no seu trabalho</h3>
                <p>
                  Em vez de perder tempo com DAS, declaração e pendências, você consegue direcionar
                  mais energia para vender, atender e crescer.
                </p>
              </div>

              <div className="note-card">
                <h3>Atendimento local e próximo</h3>
                <p>
                  A L&P atende com suporte direto em {company.city}, unindo praticidade, segurança
                  e acompanhamento para o microempreendedor.
                </p>
              </div>
            </div>

            <div style={{ textAlign: "center", marginTop: "40px" }}>
              <a
                href={`https://wa.me/${company.whatsappNumber}?text=${encodeURIComponent(
                  "Olá! Vim pelo site da L&P Assessoria Empresarial e quero saber mais sobre o plano de assessoria para MEI."
                )}`}
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Quero saber mais
              </a>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="center-heading">
              <span className="tag">IRPF 2026</span>
              <h2 className="section-title">
                Declare seu Imposto de Renda 2026 com mais segurança e menos dor de cabeça
              </h2>
              <p>
                Evite erros, atraso na entrega, pendências com a Receita e risco de cair na malha fina.
                Conte com suporte profissional para declarar com mais tranquilidade, organização e segurança.
              </p>
            </div>

            <div className="irpf-columns">
              <div className="irpf-panel">
                <h3 className="irpf-panel-title">Vantagens do atendimento</h3>

                <div className="irpf-list">
                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Menos risco de erros no preenchimento e na transmissão da declaração</p>
                  </div>

                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Mais segurança no envio correto das informações à Receita Federal</p>
                  </div>

                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Revisão mais cuidadosa de dados, rendimentos, despesas e documentos</p>
                  </div>

                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Menor chance de inconsistências que podem gerar pendências futuras</p>
                  </div>
                </div>
              </div>

              <div className="irpf-panel">
                <h3 className="irpf-panel-title">Por que contratar apoio</h3>

                <div className="irpf-list">
                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Atendimento com análise mais atenta ao seu caso e à sua realidade</p>
                  </div>

                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Mais praticidade para resolver tudo com agilidade e menos dor de cabeça</p>
                  </div>

                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Economia de tempo ao evitar dúvidas, correções e ajustes posteriores</p>
                  </div>

                  <div className="irpf-item">
                    <span className="irpf-check">✔</span>
                    <p>Mais segurança para decidir sobre deduções, bens, rendimentos e dependentes</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="irpf-cta">
              <a
                href={`https://wa.me/${company.whatsappNumber}?text=${encodeURIComponent(
                  "Olá! Vim pelo site da L&P Assessoria Empresarial e gostaria de falar com um especialista sobre IRPF 2026."
                )}`}
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Fale Conosco
              </a>
            </div>
          </div>
        </section>

        <section className="section cta-section">
          <div className="container cta-box">
            <div>
              <span className="tag">Atendimento estratégico</span>
              <h2 className="section-title">Sua empresa precisa de estrutura. Não de improviso.</h2>
              <p>
                Fale com a L&P Assessoria Empresarial para entender o melhor caminho para regularizar,
                reorganizar ou fortalecer a estrutura do seu negócio.
              </p>
            </div>
            <div className="cta-actions">
              <button className="btn btn-primary" onClick={scrollToContact}>
                Solicitar Análise
              </button>
              <a
                className="btn btn-outline light-outline"
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
              >
                Entrar em Contato
              </a>
            </div>
          </div>
        </section>

        <section id="investimento" className="section">
          <div className="container">
            <div className="center-heading">
              <span className="tag">Investimento</span>
              <h2 className="section-title">Serviços societários, licenciamentos e adicionais</h2>
              <p>
                Valores referentes aos honorários pelos serviços. Taxas municipais, estaduais e
                vistorias são cobradas à parte.
              </p>
            </div>

            <div className="pricing-table-wrapper">
              <table className="pricing-table">
                <thead>
                  <tr>
                    <th>Serviço</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {pricing.map((item, index) => (
                    <tr key={index}>
                      <td>{item[0]}</td>
                      <td>{item[1]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="notes-grid">
              <div className="note-card">
                <h3>Condições de pagamento</h3>
                <p>50% no início do processo e 50% ao final.</p>
              </div>

              <div className="note-card">
                <h3>Importante</h3>
                <p>
                  A viabilidade e a exigência de alvarás e licenças dependem da legislação local
                  e da atividade exercida.
                </p>
              </div>

              <div className="note-card">
                <h3>Atendimento sob demanda</h3>
                <p>
                  O escopo e os valores podem ser ajustados conforme o volume de demandas e o fluxo
                  operacional entre as partes.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="contato" className="section section-light">
          <div className="container contact-grid">
            <div className="contact-info-box">
              <span className="tag dark">Contato</span>
              <h2 className="section-title dark-text">Fale com a L&P Assessoria Empresarial</h2>
              <p>
                Envie sua mensagem e receba um direcionamento inicial para sua demanda empresarial,
                societária, contratual, regulatória, domicílio fiscal ou relacionada ao MEI.
              </p>

              <div className="contact-list">
                <div>
                  <strong>Empresa</strong>
                  <span>{company.name}</span>
                </div>
                <div>
                  <strong>WhatsApp</strong>
                  <span>{company.whatsappDisplay}</span>
                </div>
                <div>
                  <strong>Instagram</strong>
                  <span>{company.instagram}</span>
                </div>
                <div>
                  <strong>E-mail</strong>
                  <span>{company.email}</span>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  placeholder="Seu nome"
                  required
                />
              </div>

              <div className="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  placeholder="Seu telefone"
                  required
                />
              </div>

              <div className="form-group">
                <label>E-mail</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Seu e-mail"
                  required
                />
              </div>

              <div className="form-group">
                <label>Mensagem</label>
                <textarea
                  name="mensagem"
                  rows="5"
                  value={formData.mensagem}
                  onChange={handleChange}
                  placeholder="Descreva sua necessidade"
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary full" disabled={isSubmitting}>
                {isSubmitting ? "Enviando..." : "Entrar em Contato"}
              </button>
            </form>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer-content">
          <div>
            <h3>L&P Assessoria Empresarial</h3>
            <p>
              Segurança jurídica, eficiência operacional e estrutura empresarial com atendimento
              técnico e personalizado.
            </p>
          </div>

          <div className="footer-right">
            <p><strong>WhatsApp:</strong> {company.whatsappDisplay}</p>
            <p><strong>Instagram:</strong> {company.instagram}</p>
            <p><strong>E-mail:</strong> {company.email}</p>
            <p>© {new Date().getFullYear()} L&P Assessoria Empresarial. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;